/**
 * RTC Protocol - Message type constants for RTC / mediasoup SFU (ESM)
 * Used as 'type' field in message envelope
 */

// RTC - Mediasoup SFU events (client -> server)
const RTCEvent = {
  // 1v1 call (backward compatible)
  INVITE: 'rtc.invite',
  ACCEPT: 'rtc.accept',
  REJECT: 'rtc.reject',
  END: 'rtc.end',
  // Room management
  JOIN: 'rtc.join',
  LEAVE: 'rtc.leave',
  CREATE_ROOM: 'rtc.createRoom',
  DESTROY: 'rtc.destroy',
  INFO: 'rtc.info',
  MEMBERS: 'rtc.members',
  LIST_ROOMS: 'rtc.listRooms',
  // Media control
  MUTE: 'rtc.mute',
  UNMUTE: 'rtc.unmute',
  // Mediasoup SFU signaling
  GET_ROUTER_RTP_CAPABILITIES: 'rtc.getRouterRtpCapabilities',
  CREATE_WEBRTC_TRANSPORT: 'rtc.createWebRtcTransport',
  CONNECT_TRANSPORT: 'rtc.connectTransport',
  PRODUCE: 'rtc.produce',
  CONSUME: 'rtc.consume',
  RESUME_CONSUMER: 'rtc.resumeConsumer',
  CLOSE_PRODUCER: 'rtc.closeProducer',
  GET_PRODUCERS: 'rtc.getProducers'
};

// RTC notifications (server -> client events)
const RTCNotification = {
  // 1v1 call
  INVITED: 'rtc.invited',
  ACCEPTED: 'rtc.accepted',
  REJECTED: 'rtc.rejected',
  ENDED: 'rtc.ended',
  // Room events
  ROOM_CREATED: 'rtc.roomCreated',
  ROOM_JOINED: 'rtc.roomJoined',
  ROOM_LEFT: 'rtc.roomLeft',
  ROOM_DESTROYED: 'rtc.roomDestroyed',
  MEMBER_JOINED: 'rtc.memberJoined',
  MEMBER_LEFT: 'rtc.memberLeft',
  // Media control
  MEMBER_MUTED: 'rtc.memberMuted',
  MEMBER_UNMUTED: 'rtc.memberUnmuted',
  // Mediasoup SFU
  NEW_PRODUCER: 'rtc.newProducer',
  PRODUCER_CLOSED: 'rtc.producerClosed',
  CONSUMER_RESUMED: 'rtc.consumerResumed'
};

// System
const SystemEvent = {
  PING: 'ping',
  PONG: 'pong',
  ERROR: 'error',
  CONNECT: 'connect',
  DISCONNECT: 'disconnect'
};

export {
  RTCEvent,
  RTCNotification,
  SystemEvent
};
